// web/js/history.js

let historyInstance = null;

// A minimal, stable replica of the old History object for React 19
const createModernHistory = (useHash = false) => {
  const listeners = new Set();

  // Listens for browser navigation events (e.g., back button)
  window.addEventListener(useHash ? 'hashchange' : 'popstate', () => {
    listeners.forEach((listener) =>
      listener({
        location: window.location,
        action: 'POP',
      })
    );
  });

  return {
    get location() {
      return window.location;
    },

    encodeLocation(location) {
      return typeof location === 'string' ? { pathname: location } : location;
    },

    // 💡 React Router v6 was missing this method for the <Link> components!
    createHref(to) {
      const path = typeof to === 'string' ? to : (to.pathname || '') + (to.search || '') + (to.hash || '');

      if (useHash) {
        return path.startsWith('#') ? path : '#' + path;
      }
      return path;
    },

    push(to, state) {
      const path = typeof to === 'string' ? to : (to.pathname || '') + (to.search || '') + (to.hash || '');

      if (useHash) {
        window.location.hash = path;
      } else {
        window.history.pushState(state, '', path);
      }

      listeners.forEach((listener) =>
        listener({
          location: window.location,
          action: 'PUSH',
        })
      );
    },

    replace(to, state) {
      const path = typeof to === 'string' ? to : (to.pathname || '') + (to.search || '') + (to.hash || '');

      if (useHash) {
        const base = window.location.href.split('#')[0];
        window.location.replace(`${base}#${path}`);
      } else {
        window.history.replaceState(state, '', path);
      }

      listeners.forEach((listener) =>
        listener({
          location: window.location,
          action: 'REPLACE',
        })
      );
    },

    listen(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

export function getHistory() {
  return historyInstance;
}

export function createBrowserHistory(debug) {
  historyInstance = createModernHistory(false);
  return historyInstance;
}

export function createHashHistory() {
  historyInstance = createModernHistory(true);
  return historyInstance;
}

export function push() {
  if (historyInstance) {
    historyInstance.push(...arguments);
  } else {
    window.location.href = arguments[0];
  }
}
